<template>
    <div class="options" :theme="theme">
        <div class="options-title">{{title ? title : 'Select an Option'}}</div>
        <div class="options-list">
            <a class="option" v-for="(option, index) of options" :key="index" @click="select(option)" :class="option.color">{{option.title}}</a>
            <a class="option grey" @click="$emit('close')">Cancel</a>
        </div>
    </div>
</template>

<script>
    export default {
        name: 'Options',
        props: {
            title: String,
            options: Array
        },
        methods: {
            select(option){
                option.fn();
                this.$emit('close');
            }
        },
        computed: {
            theme(){
                return this.$store.state.theme.active;
            }
        }
    }
</script>

<style scoped lang="less">
    @import "~@/assets/less/variables";

    @option_height: 40px;

    .options
    {
        width: 260px;
        background: var(--modal-background-color);
    }

    .options-title
    {
        font-size: 12px;
        color: @lightgrey;
        min-height: @option_height;
        line-height: @option_height - (12 * 2);
        text-align: center;
        padding: 12px 20px;
    }

    .option
    {
        display: block;
        height: @option_height;
        line-height: @option_height;
        font-weight: 500;
        border-top: 1px solid var(--border-color);
        text-align: center;
        font-size: 15px;
        color: @base;
        transition: background-color ease 0.2s;
        cursor: pointer;
        user-select: none;

        &.grey
        {
            color: @grey;
        }

        &.red
        {
            color: @red;
        }

        &:hover, &:active
        {
            background: #282828;
        }
    }
</style>
